<template>
  <div class="body">
    <div class="topTitle">
      <p class="title">图纸集</p>
    </div>
    <!-- 图纸集 -->
    <div class="sheetSet">
      <!-- 左侧-图纸集目录 -->
      <div class="left_slider">
        <left @toSetIsMajor="toSetIsMajor" @toQueryList="toQueryList"></left>
      </div>

      <!-- 右侧-图纸集展示 -->
      <div class="right_slider">
        <right ref="sheetSetRight"></right>
      </div>
    </div>
  </div>
</template>

<script>
import left from "./sheetSetLeft/left.vue";
import right from "./sheetSetRight/right.vue";

export default {
  name: "SheetSet",
  components: { left, right },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    toSetIsMajor() {
      this.$refs.sheetSetRight.toSetIsMajorTwo();
    },
    toQueryList() {
      this.$refs.sheetSetRight.queryList();
    }
  }
};
</script>

<style lang='scss' scoped>
.body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  .topTitle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #e5e8f1;
    padding: var(--middle-space) var(--big-space);
    .title {
      color: var(--key-color);
      font-size: 16px;
  
      font-weight: 700;
    }
  }
  .sheetSet {
    width: 100%;
    height: calc(100% - 22px - var(--middle-space) * 2);
    padding: 10px;
    background-color: #ffffff;

    display: flex;

    .left_slider {
      width: 330px;
      height: 100%;
      border-right: 1px solid #e5e8f1;
    }

    .right_slider {
      width: calc(100% - 330px);
      height: 100%;
    }
  }
}
</style>
